<script setup>
/**
 * 정기구독 정보 본문(카드 + 이용가이드/해지 메뉴).
 * - SmartwelSubscriptionInfoSheet(오버레이)와 구독관리 '구독 정보' 탭(인라인)에서 공용 재사용
 * - 데이터/상태는 부모(시트/페이지)가 props로 주입
 */
defineProps({
  cancelRequested: { type: Boolean, default: false },
  planName: { type: String, default: '정기구독' },
  startDate: { type: String, default: '-' },
  endDate: { type: String, default: '-' },
  nextRenewal: { type: String, default: '-' },
});
const emit = defineEmits(['guide', 'resume']);
</script>

<template>
  <div class="pop-sub-card">
    <div class="pop-sub-status-row">
      <span class="pop-sub-status">{{ cancelRequested ? '해지 예정' : '구독 중' }}</span>
      <!-- 해지예정도 종료일까지 status는 ACTIVE이므로 배지는 항상 ACTIVE (해지예정 뉘앙스는 좌측 텍스트가 담당) -->
      <span class="pop-sub-badge">ACTIVE</span>
    </div>
    <div class="pop-sub-info-row">
      <span class="label">구독 상품</span>
      <span class="value">{{ planName }}</span>
    </div>
    <div class="pop-sub-info-row">
      <span class="label">구독 시작일</span>
      <span class="value">{{ startDate }}</span>
    </div>
    <div class="pop-sub-info-row">
      <span class="label">{{ cancelRequested ? '이용 종료일' : '다음 결제일' }}</span>
      <span class="value">{{ cancelRequested ? endDate : nextRenewal }}</span>
    </div>
  </div>

  <div v-if="cancelRequested" class="pop-sub-cancel-notice">
    해지 신청이 접수되었습니다. <strong>{{ endDate }}</strong
    >까지 이용 가능하며, 이후 자동 갱신되지 않습니다.
  </div>

  <div class="pop-menu">
    <div class="pop-menu-item" @click="emit('guide')">
      <span>📜 이용 가이드</span>
      <i class="pop-menu-arrow" aria-hidden="true" />
    </div>
    <!-- 해지 신청 취소(되돌리기)는 유지. '구독 해지하기'는 구독관리 페이지 '구독 해지' 탭에서만 가능 -->
    <div v-if="cancelRequested" class="pop-menu-item" @click="emit('resume')">
      <span>🔄 해지 신청 취소</span>
      <i class="pop-menu-arrow" aria-hidden="true" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.pop-sub-card {
  background: linear-gradient(135deg, #1e3a5f 0%, #2c4a75 100%);
  border-radius: 14px;
  padding: 18px 20px;
  color: #fff;
  margin-bottom: 14px;
}

.pop-sub-status-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.pop-sub-status {
  font-size: 18px;
  font-weight: 700;
}

.pop-sub-badge {
  background: #10b981;
  color: #fff;
  font-size: 10.5px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 100px;

  &--cancel {
    background: #f59e0b;
  }
}

.pop-sub-cancel-notice {
  background: #fef3e2;
  border-left: 3px solid #f59e0b;
  border-radius: 10px;
  padding: 11px 14px;
  margin-bottom: 14px;
  font-size: 12px;
  line-height: 1.5;
  color: #92400e;
  font-weight: 500;

  strong {
    color: #78350f;
    font-weight: 700;
  }
}

.pop-sub-info-row {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  padding: 3px 0;

  .label {
    opacity: 0.75;
  }

  .value {
    font-weight: 700;
  }
}

.pop-menu {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.pop-menu-item {
  padding: 12px 4px;
  font-size: 15px;
  color: #1f2937;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  transition: background 0.15s;

  &:hover {
    background: #f9fafb;
  }

  &.danger {
    color: #dc2626;
  }
}

.pop-menu-arrow {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  background: url('@manseImages/icon_dropdown.svg') no-repeat center / contain;
  transform: rotate(-90deg);
}
</style>
